<template>
  <div class="carTypeList">
    <div class="sousuo">
      <div class="flexbox">
        <van-icon name="search" color="#9B9B9B" />
        <input type="text" class="inputbox" placeholder="请输入品牌型号" v-model="pinpai" />
      </div>
      <span class="soutext" @click="getSousuo">搜索</span>
    </div>
    <div class="container" v-if="!isshow">
      <img :src="imgUrl" alt />
      <p>很遗憾没有找到你的车型</p>
      <button @click="back">返回核对信息</button>
    </div>
    <div class="other-container" v-if="isshow">
      <div class="wrap">
        <div class="type-content" v-for="(item,index) in carList" :key='index' @click="getIndex(index)">
          <van-radio-group style="float:left;margin-right:10px" v-model="raiod">
            <van-radio :name="index" checked-color="#F29600"></van-radio>
          </van-radio-group>
          <div class="info-content">
            <h1>{{item.modelName}}</h1>
            <div class="info-li">
              <li>车系:{{item.import_Flag}}</li>&nbsp;
              <li>排量:{{item.exhaustCapacity}}ml</li>&nbsp;
              <li>吨位:{{item.vehicleTonnage === '' ? 0 : item.vehicleTonnage}}kg</li>&nbsp;
              <li>年款:{{item.marketYear}}</li>&nbsp;
              <li>{{item.seatCount}}座</li>
            </div>
            <div class="info-li">新车购置价:{{item.purchasePrice}} 车型种类:{{item.importFlag}}</div>
            <div class="info-li">行业车型编码:{{item.platVehicleCode}}</div>
            <div class="info-li">备注:{{item.remark}}</div>
          </div>
        </div>
      </div>
      <div class="commit-content" v-show="goNextBtn">
        <button @click="nevigateTo">确定</button>
        <p>如果没有正确车型，请返回核实品牌型号与车架号</p>
      </div>
    </div>
    <Loading :switchs="switchs" />
    <check-code :yzm='yzm' :yzmNum='yzmNum' @submitResult='submit' @changeyzm='checkout' @cancle='cancle' v-show="isPop"/>
  </div>
</template>
<script>
import api from "@/api/api.js";
import { Icon,Toast } from "vant";
import CheckCode from '@/components/CheckCode/index'
import Loading from '@/components/Loadings/Loading'
export default {
  data() {
    return {
      switchs: false,
      raiod: -1,
      imgUrl: api.imgAllUrl + "/sales190709.png",
      isshow: true,
      yzm: "", // 验证码图片
      yzmNum: "", //验证码
      error: false, //错误提示
      checkNo: "",
      isPop: false, //弹窗
      carList: [], //车型数据
      paramsObj: {},//传来的数据
      orderId: "", //订单id
      orderNo: "", //订单号
      pinpai: "", //品牌车型
      goNextBtn: true,
      originHeight:''
    };
  },
  components: {
    "van-icon": Icon,
    "check-code":CheckCode,
    "Loading": Loading
  },
  watch: {
    pinpai(value) {
      this.pinpai = value.toUpperCase()
    }
  },
  activated() {
    this.originHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0
    let u = navigator.userAgent
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 //g
    let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
    if (isAndroid) {
        //这个是安卓操作系统
        window.addEventListener('resize', this.resizeFn)
    }
    if (isIOS) {
    　　//这个是ios操作系统
    }
    this.$store.commit('setShow',false)
    this.raiod = -1;
    this.isshow = true;
    this.carList = [];
    this.paramsObj = {};
    if (this.$store.state.orderId !== '' && this.$store.state.orderId !== null && this.$store.state.orderId !== undefined) {
      this.orderId = this.$store.state.orderId
    }
    this.paramsObj = this.$route.params;
    this.pinpai= this.$route.params.brandType.replace(/[\u4e00-\u9fa5]/g, '');
    this.getQueryVehicleModelDto();
  },
  deactivated(){
    Toast.clear()
    window.removeEventListener("resize", this.resizeFn)
    this.goNextBtn = true
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeFn)
    this.goNextBtn = true
  },
  methods: {
    resizeFn(){
      let resizeHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0
      if(this.originHeight-0 > resizeHeight-0){
        this.goNextBtn = false
      }else{
        this.goNextBtn = true
      }
    },
    cancle() {
      this.isPop = false;
    },
    //更换验证码
    checkout() {
      this.getQueryVehicleModelDto();
    },
    //搜索
    getSousuo() {
      this.getQueryVehicleModelDto();
    },
    getIndex(el) {
      this.raiod = el;
    },
    nevigateTo () {
      //如果为空就是新订单
      if(this.$store.state.orderId===''||this.$store.state.orderId===undefined){
        this.$store.commit('setOrderId', this.orderId)
        console.log(this.orderId,this.$store.state.setOrderId,141);
      }
      let obj = this.carList[this.raiod]
      this.$router.replace({
        name:'Vehicle',
        params:{
          result:obj,
          orderId:this.orderId,
          orderNo:this.orderNo,
        }
      })
    },
    back() {
      this.$router.go(-1);
    },
    getQueryVehicleModelDto() {
      this.switchs = true
      this.carList = []
      let carQueryVehicleModelDto = {
        baseInfo: {
          introduceAgreementNo: this.paramsObj.introduceAgreementNo,
          introduceCode: this.paramsObj.userCode,
          introduceName: this.paramsObj.userName
        },
        brandName: this.pinpai,
        comCode: this.paramsObj.newCodeCode,
        certificateDate: this.paramsObj.certificateDate,
        engineNo: this.paramsObj.engineNum,
        enrollDate: this.paramsObj.registData,
        licenseNo: this.paramsObj.noLicenseFlag === '0' ? '' : this.paramsObj.cardNum,
        orderId: this.orderId,
        vINNo: this.paramsObj.vehicleInfo,
        productCode: 'CAR20190517',
        productName: '驾驶无忧险',
        terminalId: localStorage.getItem('setTerminalId'),
        orderOrigin: localStorage.getItem('setChannelCode'),
        channelCode: localStorage.getItem('setChannelCode'),
        insuranceSign: '0'
      }
      if (this.paramsObj.newCodeCode === '510000') {
        carQueryVehicleModelDto.licenseKindCode = this.paramsObj.licenseKindCode
      }
      if (this.paramsObj.newCodeCode === '320000') {
        carQueryVehicleModelDto.channelCode = ''
      }
      this.$http
        .post(api.queryVehicleModel, carQueryVehicleModelDto)
        .then(res => {
          if (res.data.rtnCode === "0002") {
            if (res.data.checkCode == null || res.data.checkNo == null) {
              this.isshow = false;
            } else {
              this.yzm = "data:image/jpeg;base64," + res.data.checkCode;
              this.checkNo = res.data.checkNo;
              this.orderId = res.data.orderId;
              this.$store.commit('setOrderId', this.orderId)
              this.orderNo = res.data.orderNo;
              this.yzmNum = "";
              this.isPop = true;
            }
             Toast.clear()
          } else if (res.data.rtnCode === "0000" || res.data.rtnCode === "011" && res.data.orderId!=='') {
            this.orderId = res.data.orderId;
            this.$store.commit('setOrderId', this.orderId)
            if (
              Array.isArray(res.data.resultObj) && res.data.resultObj.length > 0
            ) {
              this.orderNo = res.data.orderNo;
              res.data.resultObj.forEach(item => {
                this.carList.push(item);
              });
              this.isshow = true;
            } else {
              this.isshow = false;
            }
            Toast.clear()
          }else {
            Toast.clear()
            this.$toast(res.data.rtnMsg)
            this.isshow = false;
          }
          this.switchs = false
        })
        .catch(error => {
          this.switchs = false
          console.log(error)
        })
    },
    submit(yzmCode) {
      this.switchs = true
      this.isPop = false;
      // let carQueryVehicleModelDto = {
      //   checkCode: yzmCode,
      //   checkNo: this.checkNo,
      //   comCode: this.paramsObj.newCodeCode,
      //   orderId: this.orderId,
      //   orderOrigin: "0",
      //   productCode: "CAR20190517",
      //   productName: "紫金车险",
      //   insuranceSign: "0"
      // }
      let carQueryVehicleModelDto = {
        checkCode: yzmCode,
        checkNo: this.checkNo,
        orderId: this.orderId,
        comCode: this.paramsObj.newCodeCode,
        productCode: 'CAR20190517',
        productName: '驾驶无忧险',
        terminalId: localStorage.getItem('setTerminalId'),
        orderOrigin: localStorage.getItem('setChannelCode'),
        channelCode: localStorage.getItem('setChannelCode'),
        insuranceSign: '0'
      }
      this.$http
        .post(api.queryVehicleModel, carQueryVehicleModelDto)
        .then(res => {
          if (res.data.rtnCode === "0000") {
            if (Array.isArray(res.data.resultObj) && res.data.resultObj.length > 0) {
              this.orderId = res.data.orderId;
              this.$store.commit('setOrderId', this.orderId)
              this.orderNo = res.data.orderNo;
              res.data.resultObj.forEach(item => {
                this.carList.push(item);
              });
              this.isshow = true;
            } else {
              this.isshow = false;
            }
            Toast.clear()
          } else {
            this.$toast(res.data.rtnMsg);
            Toast.clear()
            this.isshow = false;
          }
          this.switchs = false
        })
        .catch(error => {
          this.switchs = false
          console.log(error)
        })
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./carTypeList.scss";
</style>



// WEBPACK FOOTER //
// src/pages/car/modelQuery/index.vue